webpackJsonp([35783957827783],{

/***/ 97:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CodePenSVG = function CodePenSVG() {
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: 'dib h2 w2',
	      fill: 'currentColor',
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 16 16',
	      fillRule: 'nonzero',
	      clipRule: 'evenodd',
	      strokeLinejoin: 'round',
	      strokeMiterlimit: '1.414'
	    },
	    _react2.default.createElement('path', { d: 'M15.988 5.443c-.004-.02-.007-.04-.012-.058l-.01-.033c-.006-.017-.012-.034-.02-.05-.003-.012-.01-.023-.014-.034l-.023-.045-.02-.032-.03-.04-.024-.03c-.01-.013-.022-.026-.034-.038l-.027-.027-.04-.032-.03-.024-.012-.01L8.38.117c-.23-.155-.53-.155-.76 0L.305 4.99.296 5c-.012.007-.022.015-.032.023-.014.01-.027.02-.04.032l-.027.027-.034.037-.024.03-.03.04c-.006.012-.013.022-.02.033l-.023.045-.015.034c-.007.016-.012.033-.018.05l-.01.032c-.005.02-.01.038-.012.058l-.006.03C.002 5.5 0 5.53 0 5.56v4.875c0 .03.002.06.006.09l.007.03c.003.02.006.04.013.058l.01.033c.006.018.01.035.018.05l.015.033c.006.016.014.03.023.047l.02.03c.008.016.018.03.03.042.007.01.014.02.023.03.01.012.02.025.034.036.01.01.018.02.028.026l.04.033.03.023.01.01 7.31 4.876c.116.078.248.117.382.116.134 0 .266-.04.38-.116l7.314-4.875.01-.01c.012-.007.022-.015.032-.023.014-.01.027-.02.04-.032l.027-.027.034-.037.024-.03.03-.04.02-.032.023-.046.015-.033.018-.052.01-.033c.005-.02.01-.038.013-.058 0-.01.003-.02.004-.03.004-.03.006-.06.006-.09V5.564c0-.03-.002-.06-.006-.09l-.007-.03zM8 9.626L5.568 8 8 6.374 10.432 8 8 9.626zM7.312 5.18l-2.98 1.993-2.406-1.61 5.386-3.59v3.206zM3.095 8l-1.72 1.15v-2.3L3.095 8zm1.237.828l2.98 1.993v3.208l-5.386-3.59 2.406-1.61zm4.355 1.993l2.98-1.993 2.407 1.61-5.387 3.59v-3.206zM12.905 8l1.72-1.15v2.3L12.905 8zm-1.237-.827L8.688 5.18V1.97l5.386 3.59-2.406 1.61z' })
	  );
	};
	
	exports.default = CodePenSVG;
	module.exports = exports['default'];

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GithubSVG = function GithubSVG() {
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: 'dib h2 w2',
	      fill: 'currentColor',
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 16 16',
	      fillRule: 'evenodd',
	      clipRule: 'evenodd',
	      strokeLinejoin: 'round',
	      strokeMiterlimit: '1.414'
	    },
	    _react2.default.createElement('path', { d: 'M8 0C3.58 0 0 3.582 0 8c0 3.535 2.292 6.533 5.47 7.59.4.075.547-.172.547-.385 0-.19-.007-.693-.01-1.36-2.226.483-2.695-1.073-2.695-1.073-.364-.924-.89-1.17-.89-1.17-.725-.496.056-.486.056-.486.803.056 1.225.824 1.225.824.714 1.223 1.873.87 2.33.665.072-.517.278-.87.507-1.07-1.777-.2-3.644-.888-3.644-3.953 0-.873.31-1.587.823-2.147-.083-.202-.358-1.015.077-2.117 0 0 .672-.215 2.2.82.638-.178 1.323-.266 2.003-.27.68.004 1.364.092 2.003.27 1.527-1.035 2.198-.82 2.198-.82.437 1.102.163 1.915.08 2.117.513.56.823 1.274.823 2.147 0 3.073-1.87 3.75-3.653 3.947.287.246.543.735.543 1.48 0 1.07-.01 1.933-.01 2.195 0 .215.144.463.55.385C13.71 14.53 16 11.534 16 8c0-4.418-3.582-8-8-8' })
	  );
	};
	
	exports.default = GithubSVG;
	module.exports = exports['default'];

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkedInSVG = function LinkedInSVG() {
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: 'dib h2 w2',
	      fill: 'currentColor',
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 16 16',
	      fillRule: 'evenodd',
	      clipRule: 'evenodd',
	      strokeLinejoin: 'round',
	      strokeMiterlimit: '1.414'
	    },
	    _react2.default.createElement('path', { d: 'M13.632 13.635h-2.37V9.922c0-.886-.018-2.025-1.234-2.025-1.235 0-1.424.964-1.424 1.96v3.778h-2.37V6H8.51V7.04h.03c.318-.6 1.092-1.233 2.247-1.233 2.4 0 2.845 1.58 2.845 3.637v4.188zM3.558 4.955c-.762 0-1.376-.617-1.376-1.377 0-.758.614-1.375 1.376-1.375.76 0 1.376.617 1.376 1.375 0 .76-.617 1.377-1.376 1.377zm1.188 8.68H2.37V6h2.376v7.635zM14.816 0H1.18C.528 0 0 .516 0 1.153v13.694C0 15.484.528 16 1.18 16h13.635c.652 0 1.185-.516 1.185-1.153V1.153C16 .516 15.467 0 14.815 0z' })
	  );
	};
	
	exports.default = LinkedInSVG;
	module.exports = exports['default'];

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GitHubSVG = __webpack_require__(221);
	
	var _GitHubSVG2 = _interopRequireDefault(_GitHubSVG);
	
	var _CodePenSVG = __webpack_require__(220);
	
	var _CodePenSVG2 = _interopRequireDefault(_CodePenSVG);
	
	var _LinkedInSVG = __webpack_require__(222);
	
	var _LinkedInSVG2 = _interopRequireDefault(_LinkedInSVG);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Socials = function Socials() {
	  return _react2.default.createElement(
	    'section',
	    { className: 'pv4 ph3 tc' },
	    _react2.default.createElement(
	      'a',
	      {
	        className: 'near-black grow dib mh3',
	        href: 'https://github.com/rongierlach',
	        target: '_blank',
	        title: 'GitHub'
	      },
	      _react2.default.createElement(_GitHubSVG2.default, null)
	    ),
	    _react2.default.createElement(
	      'a',
	      {
	        className: 'near-black grow dib mh3',
	        href: 'https://codepen.io/youfoundron',
	        target: '_blank',
	        title: 'CodePen'
	      },
	      _react2.default.createElement(_CodePenSVG2.default, null)
	    ),
	    _react2.default.createElement(
	      'a',
	      {
	        className: 'near-black grow dib mh3',
	        href: 'https://www.linkedin.com/in/rongierlach',
	        target: '_blank',
	        title: 'LinkedIn'
	      },
	      _react2.default.createElement(_LinkedInSVG2.default, null)
	    )
	  );
	};
	
	exports.default = Socials;
	module.exports = exports['default'];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Socials = __webpack_require__(223);
	
	var _Socials2 = _interopRequireDefault(_Socials);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Socials2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 227:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  head: {
	    title: 'Found Him.',
	    meta: [{ name: 'description', content: 'This is a website.' }],
	    links: [{ rel: 'canonical', href: 'https://youfoundron.com' }]
	  }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _home = __webpack_require__(227);
	
	var _Head = __webpack_require__(55);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _Socials = __webpack_require__(224);
	
	var _Socials2 = _interopRequireDefault(_Socials);
	
	var _Container = __webpack_require__(21);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _FadeInUp = __webpack_require__(27);
	
	var _FadeInUp2 = _interopRequireDefault(_FadeInUp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Copy = function Copy(props) {
	  return _react2.default.createElement('p', _extends({ className: 'f5 f4-ns lh-copy' }, props));
	};
	
	var Callout = function Callout(props) {
	  return _react2.default.createElement(_gatsbyLink2.default, _extends({ className: 'sans-serif link fw9 black hover-gold' }, props));
	};
	
	var HomePage = function HomePage() {
	  return _react2.default.createElement(
	    _Container2.default,
	    null,
	    _react2.default.createElement(_Head2.default, _home.head),
	    _react2.default.createElement(
	      _FadeInUp2.default,
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'pv5 center measure georgia' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'sans-serif' },
	          'Found Me.'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          Copy,
	          null,
	          'I\'m a ',
	          _react2.default.createElement(
	            'strike',
	            { className: 'strike' },
	            'Chicago'
	          ),
	          ' San Francisco based software developer, currently writing web apps and smart contracts at ',
	          _react2.default.createElement(
	            'a',
	            { className: 'sans-serif link fw9 black hover-gold', href: 'https://www.tokensoft.io/', target: '_blank' },
	            'TokenSoft'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          Copy,
	          null,
	          'I\'ve done varied ',
	          _react2.default.createElement(
	            Callout,
	            { to: '/work' },
	            'work'
	          ),
	          ' for some pretty interesting clients.'
	        ),
	        _react2.default.createElement(
	          Copy,
	          null,
	          'Sparingly, I may ',
	          _react2.default.createElement(
	            Callout,
	            { to: '/blog' },
	            'write'
	          ),
	          ' about programming and related topics.'
	        ),
	        _react2.default.createElement(
	          Copy,
	          null,
	          'If you\'re interested in working together, or just feel like connecting, let\'s ',
	          _react2.default.createElement(
	            Callout,
	            { to: '/contact' },
	            'get in touch'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(_Socials2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = HomePage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-41dfa31504d040377040.js